import { HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { AngularFireFunctions } from '@angular/fire/compat/functions';
import { CalculatorInput, CalculatorOutput } from 'src/app/core/domain/calculator-domain';
import { FunctionOptions } from 'src/app/core/domain/function-options';
import { BaseService } from 'src/app/core/services/base.service';
import {
    COMPANY_ADVANTAGE_CALCULATE_FUNCTION,
    CREATE_COMPANY_LEAD
} from '../../../app.constants';
import { FireLoggingService } from '../../../core/services/fire-logging.service';

@Injectable({
    providedIn: 'root'
})
export class CalculatorService extends BaseService {

    public showResultForm: EventEmitter<any> = new EventEmitter();
    public resetResultForm: EventEmitter<any> = new EventEmitter();
    public calculatorInput: CalculatorInput;
    public calculatorResult: CalculatorOutput;

    constructor(
        protected firestore: AngularFirestore,
        protected http: HttpClient,
        protected functions: AngularFireFunctions,
        protected fireLogging: FireLoggingService,
    ) {
        super(firestore, http, functions, fireLogging);
    }

    sendCompanyAdvantage(formData: any) {
        return this.callFunction(formData, COMPANY_ADVANTAGE_CALCULATE_FUNCTION, new FunctionOptions('callable'));
    }

    createCompanyLead(formData: any) {
        return this.callFunction(formData, CREATE_COMPANY_LEAD, new FunctionOptions('callable'));
    }

}
